import { ClientDataGuard } from './client/client-data.guard';
import { DecedentInfoGuard } from './decedent-info/decedent-info.guard';
import { DivorceEligibilityGuard } from './eligibility/divorce-eligibility/divorce-eligibility.guard';
import { DivorceEligibilityMultiItGuard } from './eligibility/divorce-eligibility-multi-it/divorce-eligibility-multi-it.guard';
import { GiftingEligibilityGuard } from './eligibility/gifting-eligibility/gifting-eligibility.guard';
import { InheritanceEligibilityGuard } from './eligibility/inheritance-eligibility/inheritance-eligibility.guard';
import { InternalTransferMultiEligibilityGuard } from './eligibility/internal-transfer/internal-transfer-multi.guard';
import { MinorEligibilityGuard } from './eligibility/minor-eligibility/minor-eligibility.guard';
import { GatekeeperGuard } from './gatekeeper/gatekeeper.guard';
import { GatekeeperOnlyForExternalGuard } from './gatekeeperOnlyForExternal/gatekeeperOnlyForExternal';
import { IncapacitatedGuard } from './incapacitated/incapacitated.guard';
import { InitStateGuard } from './init-state/init-state.guard';
import { MultiTriageGuard } from './multi-triage/multi-triage.guard';
import { PersonalInfoGuard } from './personal-info/personal-info.guard';
import { SubmitGuard } from './submit/submit.guard';
import { SubmitDeactivateGuard } from './submit/submit-deactivate.guard';
import { TransactionsGuard } from './transactions/transactions.guard';
import { TriageGuard } from './triage/triage.guard';

export const guards: any[] = [
  ClientDataGuard,
  GatekeeperGuard,
  GatekeeperOnlyForExternalGuard,
  GiftingEligibilityGuard,
  IncapacitatedGuard,
  InheritanceEligibilityGuard,
  InitStateGuard,
  InternalTransferMultiEligibilityGuard,
  MinorEligibilityGuard,
  MultiTriageGuard,
  TriageGuard,
  DivorceEligibilityGuard,
  DivorceEligibilityMultiItGuard,
  PersonalInfoGuard,
  DecedentInfoGuard,
  TransactionsGuard,
  SubmitGuard,
  SubmitDeactivateGuard,
];

// Consolidated guards
export * from './client/client-data.guard';
export * from './init-state/init-state.guard';

// Other guards
export * from './gatekeeper/gatekeeper.guard';
export * from './gatekeeperOnlyForExternal/gatekeeperOnlyForExternal';
export * from './incapacitated/incapacitated.guard';
export * from './eligibility/internal-transfer/internal-transfer.guard';
export * from './eligibility/inheritance-eligibility/inheritance-eligibility.guard';
export * from './eligibility/gifting-eligibility/gifting-eligibility.guard';
export * from './eligibility/minor-eligibility/minor-eligibility.guard';
export * from './experimentation/experimentation.guard';
export * from './triage/triage.guard';
export * from './eligibility/divorce-eligibility/divorce-eligibility.guard';
export * from './eligibility/divorce-eligibility-multi-it/divorce-eligibility-multi-it.guard';
export * from './personal-info/personal-info.guard';
export * from './decedent-info/decedent-info.guard';
export * from './transactions/transactions.guard';
export * from './eligibility/internal-transfer/internal-transfer-multi.guard';
export * from './submit/submit.guard';
export * from './submit/submit-deactivate.guard';
export * from './multi-triage/multi-triage.guard';
